import { SafeBaseObject } from "@app/core/models/base-object.models";
import { DateTime } from "luxon";


export interface IResApiGetProperties {
  ID?: number;
  Name?: string;
  City?: string;
  Country?: string;
  ProductCod?: string;
  Status?: string;
  PageSize?: number;
}
export class ResAdmProperty extends SafeBaseObject {
  propertyID = 0
  productCod = ''
  name = '';
  shortName = '';
  description = '';
  maxOccupancy = 0;
  bedrooms = 0;
  cityID = 0;
  city = '';
  countryID = 0;
  country = '';
  propertyGroup = '';
  propertyGroupID = 0;
  startDate = DateTime.invalid('Empty');
  endDate = DateTime.invalid('Empty');
  webSiteVisibilityFrom = DateTime.invalid('Empty');
  webSiteVisibilityTo = DateTime.invalid('Empty');
  isReservationOpen = false;
  isWebSiteOpen = false;
  status = '';

  constructor(data?: any) {
    super();
    if (data) {
      this.updateData(data);
    }
  }
  override updateData(data: any): void {
    if (!data) return
    super.updateData(data)
    this.addProperty('propertyID', data, 'ID');
  }
}
export class ResPropertyHeader extends SafeBaseObject {
  propertyID = 0;
  productCod = '';
  name = '';
  shortName = '';
  description = '';
  maxOccupancy = 0;
  bedrooms = 0;
  cityID = 0;
  city = '';
  propertyGroup = '';
  propertyGroupID = 0;
  status = '';
  startDate = DateTime.invalid('Empty');
  endDate = DateTime.invalid('Empty');
  webSiteVisibilityFrom = DateTime.invalid('Empty');
  webSiteVisibilityTo = DateTime.invalid('Empty');
  supplierID = 0;
  supplierName = ''
  ownerCompanyID = 0;
  dmcCompanyID = 0;
  checkInDayID = 0;
  address = ''
  longitude?: number
  latitude?: number
  kicker = ''
  companyID: any
  companiesID: number[] = []
  passportInfoMandatory = false
  kindlyNote = ''
  checkIN = DateTime.invalid('Empty')
  checkOUT = DateTime.invalid('Empty')
  sqm = 0
  bathrooms = 0
  flagAKRapr = false
  flagConsierge = false
  styleCategoryCod = ''
  regionCod = ''
  campSupplierID?: number
  mainCurrency = ''
  location = ''

  get isVilla(): boolean {
    return this.productCod === 'VLL';
  }
  get isCamp(): boolean {
    return this.productCod === 'CMP';
  }

  constructor(data: any) {
    super();
    this.updateData(data);
  }
  override updateData(data: any): void {
    if (!data) return
    super.updateData(data)
    this.addProperty('propertyID', data, 'ID');
  }
}

export class ResPropertyDetails extends SafeBaseObject {
  currencies: string[] = []
  priceTypes: any[] = []

  validityDates: ResPropertyValidityDate[] = []
  travelDates: ResPropertyTravelDate[] = []
  header: ResPropertyHeader = new ResPropertyHeader({})
  prices: ResPropertyPrice[] = []
  companies: ResPropertyCompany[] = []
  allCountryIDPassportInfoMandatory: number[] = []

  constructor(data: any) {
    super();
    if (data) this.updateData(data);
    this.currencies = data?.DT0 ? data.DT0.map((data: any) => data.CurrencyCod) : []
    this.priceTypes = data?.DT1
    this.validityDates = data?.DT2 ? data.DT2.map((data: any) => new ResPropertyValidityDate(data)) : []
    this.travelDates = data?.DT3 ? data.DT3.map((data: any) => new ResPropertyTravelDate(data)) : []
    this.header = data?.DT4 ? new ResPropertyHeader(data?.DT4[0]) : new ResPropertyHeader({})
    this.prices = data?.DT5 ? data.DT5.map((data: any) => new ResPropertyPrice(data)) : []
    this.companies = data?.DT6 ? data.DT6.map((data: any) => new ResPropertyCompany(data)) : []
    this.header.styleCategoryCod = data?.DT7 ? data.DT7.map((data: any) => data.CodCategoryStyle) : []
    this.allCountryIDPassportInfoMandatory = data?.DT8 ? data.DT8.map((data: any) => data.CountryID) : []
    this.header.companiesID = this.companies.map((company) => company.companyID)
  }

}

export class ResPropertyDetailsPrice extends SafeBaseObject {
  currencies: string[] = []
  priceTypes: any[] = []
  validityDates: ResPropertyValidityDate[] = []
  travelDates: ResPropertyTravelDate[] = []
  header: ResPropertyHeader = new ResPropertyHeader({})
  prices: ResPropertyPrice[] = []

  constructor(data: any) {
    super();
    if (data) this.updateData(data);
    this.currencies = data.DT0.map((data: any) => data.CurrencyCod)
    this.priceTypes = data.DT1
    this.validityDates = data.DT2.map((data: any) => new ResPropertyValidityDate(data))
    this.travelDates = data.DT3.map((data: any) => new ResPropertyTravelDate(data))
    this.header = new ResPropertyHeader(data.DT4[0])
    this.prices = data.DT5.map((data: any) => new ResPropertyPrice(data))
  }

}

export class ResPropertyPrice extends SafeBaseObject {
  propertyPriceID = 0
  name = ''
  propertyID = 0
  nightFrom = 0
  nightTo = 0
  travelStartDate?: DateTime = DateTime.invalid('Empty')
  travelEndDate?: DateTime = DateTime.invalid('Empty')
  priceSingle = 0
  priceDouble = 0
  priceExtraGuest = 0
  priceChild = 0
  sellingPrice = 0
  sellingPriceNight = 0
  priceTypeID = 0
  priceTypeName = ''
  suiteCategoryID = 0
  startDate = DateTime.invalid('Empty')
  endDate = DateTime.invalid('Empty')
  currency = ''
  web = false
  res = false
  status = 'A'
  cost = 0
  costNight = 0
  costCurrency = ''
  note = ''
  invoiceTax = 0
  localTax = 0
  paxFrom = 0
  paxTo = 0

  formattedTravelStartDate = ''
  formattedTravelEndDate = ''
  formattedPriceSingle = ''
  formattedPriceDouble = ''
  formattedPriceExtraGuest = ''
  formattedPriceChild = ''
  formattedSellingPrice = ''
  formattedCost = ''
  formattedInvoiceTax = ''
  formattedLocalTax = ''

  formattedSellingPriceNight = ''
  formattedCostNight = ''

  travelDateID = ''
  edited = false
  new = false

  constructor(data?: any) {
    super()
    if (data) this.updateData(data)
    this.formatDateTimeProperties()
    if (!this.costCurrency) this.costCurrency = this.currency
    this.sellingPriceNight = Math.round(this.sellingPrice / 7)
    this.costNight = Math.round(this.cost / 7)
    this.formatCurrencyAmountProperties(['priceSingle', 'priceDouble', 'priceExtraGuest', 'priceChild', 'sellingPrice', 'sellingPriceNight'], this.currency)
    this.formatCurrencyAmountProperties(['cost', 'costNight', 'localTax'], this.costCurrency)
    this.formatCurrencyAmountProperties(['invoiceTax'])

    this.travelDateID = `${this.formattedTravelStartDate}-${this.formattedTravelEndDate}-${this.suiteCategoryID}`
  }

  static new(from: ResPropertyTravelDate, currency: string, priceTypeID: number, nightFrom: number, nightTo: number, paxFrom: number, paxTo: number): ResPropertyPrice {
    const newPrice = new ResPropertyPrice({})
    newPrice.propertyID = from.propertyID
    newPrice.travelStartDate = from.travelStartDate
    newPrice.travelEndDate = from.travelEndDate
    newPrice.travelDateID = from.travelDateID
    newPrice.nightFrom = nightFrom
    newPrice.nightTo = nightTo
    newPrice.suiteCategoryID = from.suiteCategoryID
    newPrice.priceTypeID = priceTypeID
    newPrice.currency = currency
    newPrice.costCurrency = currency
    newPrice.new = true
    newPrice.propertyPriceID = -Math.floor(Math.random() * 1000000)
    newPrice.paxFrom = paxFrom
    newPrice.paxTo = paxTo
    newPrice.web = true
    newPrice.res = true
    return newPrice
  }
}

export class ResPropertyTravelDate extends SafeBaseObject {
  propertyID = 0
  suiteCategoryID = 0
  suiteCategory = ''
  nightFrom = 0
  nightTo = 0
  travelStartDate?: DateTime = DateTime.invalid('Empty')
  travelEndDate?: DateTime = DateTime.invalid('Empty')
  startDate = DateTime.invalid('Empty')
  endDate = DateTime.invalid('Empty')

  formattedTravelStartDate = ''
  formattedTravelEndDate = ''

  travelDateID = ''
  new = false
  placeholder = false

  constructor(data: any) {
    super()
    this.updateData(data)
    this.formatDateTimeProperties()

    this.travelDateID = `${this.formattedTravelStartDate}-${this.formattedTravelEndDate}-${this.suiteCategoryID}`
  }

  static new(propertyID: number, suiteCategoryID?: number, suiteCategory?: string, travelStartDate?: DateTime, travelEndDate?: DateTime): ResPropertyTravelDate {
    const newTravelDate = new ResPropertyTravelDate({})
    newTravelDate.propertyID = propertyID
    newTravelDate.suiteCategoryID = suiteCategoryID ?? 0
    newTravelDate.suiteCategory = suiteCategory ?? ''
    newTravelDate.travelStartDate = travelStartDate
    newTravelDate.travelEndDate = travelEndDate
    newTravelDate.new = true
    newTravelDate.travelDateID = (-Math.floor(Math.random() * 1000000)).toString()
    return newTravelDate
  }

  static placeholder(): ResPropertyTravelDate {
    const placeholder = new ResPropertyTravelDate({})
    placeholder.placeholder = true
    return placeholder
  }
}

export class ResPropertyValidityDate extends SafeBaseObject {
  propertyID = 0;
  startDate = DateTime.invalid('Empty');
  endDate = DateTime.invalid('Empty');

  formattedStartDate = '';
  formattedEndDate = '';

  current = false;

  constructor(data: any) {
    super();
    this.updateData(data);
    this.formatDateTimeProperties();
  }
}

export class ResVillaDetail extends SafeBaseObject {
  airCon = ''
  chefService = false
  isAnimalAccepted = false
  isChildFriendly = false
  isFavourite = false
  isGoldPackage = false
  isInternetAvailable = false
  isPlatinumPackage = false
  isPool = false
  isPoolHeating = false
  isWedding = false
  isWheelChairFriendly = false
  minRentalPeriod = 0
  priceRange = ''
  noRecommendations = 0;
  shorterStay = false;
  status = '';
  villaDetailID = 0;
  villaID = 0;
  villaStaff = '';

  constructor(data: any) {
    super();
    this.updateData(data);
  }
}

export class ResVillaDistance extends SafeBaseObject {
  villaDistanceID = 0
  distance = 0
  distanceCod = ''
  distanceToID = 0
  distanceToName = ''
  distanceUnit = ''
  latitude?: number
  longitude?: number
  name = ''
  note = ''
  propertyID = 0
  status = ''

  constructor(data: any) {
    super();
    this.updateData(data);
  }
}

export class ResVillaDistances extends SafeBaseObject {
  cod = ''
  type = ''

  constructor(data: any) {
    super();
    this.updateData(data);
  }
}

export class ResVillaDistanceUnit extends SafeBaseObject {
  cod = ''
  type = ''

  constructor(data: any) {
    super();
    this.updateData(data);
  }
}


export class ResVillaFeature extends SafeBaseObject {
  villaToFeatureID = 0;
  villaFeatureID = 0;
  villaID = 0;
  feature = '';
  status = '';

  constructor(data: any) {
    super();
    this.updateData(data);
  }
}

export class ResVillaSingleFeature extends SafeBaseObject {
  villaFeatureID = 0;
  feature = '';

  constructor(data: any) {
    super();
    this.updateData(data);
  }
}


export interface IResApiPropertyManageParams {
  ID?: number
  ProductCod?: string
  Name?: string
  ShortName?: string
  Description?: string
  MaxOccupancy?: number
  Bedrooms?: number
  CityID?: number
  PropertyGroupID?: number
  StartDate?: DateTime
  EndDate?: DateTime
  Status?: string
  WebSiteVisibilityFrom?: DateTime
  WebSiteVisibilityTo?: DateTime
  SupplierID?: number
  CurrencyCod?: string
  IsMainPage?: string
  IsReservationOpen?: string
  IsWebSiteOpen?: string
  OwnerCompanyID?: number
  DmcCompanyID?: number
  CheckInDayID?: number
  CompanyID?: string
  Address?: string
  Latitude?: number
  Longitude?: number
  Kicker?: string
  PassportInfoMandatory?: string
  KindlyNote?: string
  CheckIN?: DateTime
  CheckOUT?: DateTime
  Sqm?: number
  Bathrooms?: number
  FlagAKRapr?: string
  FlagConsierge?: string
  InternalNotes?: string
  StyleCategory?: string
  RegionCod?: string
  CampSupplierID?: number
  KickerAI?: string
  DescriptionAI?: string
  MainCurrency?: string
  Location?: string
}

export class ResAdmVillaPreAuthAmount extends SafeBaseObject {
  shipID = 0
  preAuthPerc?: number
  moneyInHouse?: number
  moneyInHouseUSD?: number
  moneyInHouseCAD?: number
  moneyInHouseAUD?: number
  moneyInHouseGBP?: number
  moneyInHousePerc?: number
  localAmount?: number
  localCurrency?: string

  constructor(data: any) {
    super();
    this.updateData(data);
  }
}

export interface IResApiManageVillaPreAuthAmount {
  ID?: number
  PreAuthPerc?: number
  MoneyInHouse?: number
  MoneyInHouseUSD?: number
  MoneyInHouseCAD?: number
  MoneyInHouseAUD?: number
  MoneyInHouseGBP?: number
  MoneyInHousePerc?: number
  MoneyToOwner?: number
  LocalAmount?: number
  LocalCurrency?: string
}

export class ResAdmPropertyDepositSchedule extends SafeBaseObject {
  depositSchedulingID = 0;
  propertyID = 0;
  paymentDueDays = 0;
  currency = '';
  isFinalPayment = false;
  amount = 0;
  percentage = 0;
  status = 'A';

  constructor(data: any) {
    super();
    this.updateData(data);
  }
}

export class ResAdmPropertyCancelPolicyHeader extends SafeBaseObject {
  cancellationPolicyID = 0;
  cancellationPolicy = '';

  constructor(data: any) {
    super();
    this.updateData(data);
  }
}

export class ResAdmPropertyCancelPolicyDetail extends SafeBaseObject {
  cancellationPolicyDetailID = 0;
  cancellationPolicyID = 0;
  daysFrom = 0;
  daysTo = 0;
  amountPerc = 0;
  fixedAmount = 0;
  packageID = 0;
  valueType = '';
  status = 'A';

  constructor(data: any) {
    super();
    this.updateData(data);
  }
}

export interface IResApiManageVillaDetailsParams {
  VillaDetailID: number
  ID: number
  ChefService: string
  IsWedding: string
  VillaStaff: string
  IsFavourite: string
  IsAnimalAccepted: string
  PriceRange: string
  IsChildFriendly: string
  MinRentalPeriod: number
  AirCon: string
  IsInternetAvailable: string
  IsPool: string
  IsPoolHeating: string
  IsWheelChairFriendly: string
  NoRecommendations: number
  IsGoldPackage: string
  IsPlatinumPackage: string
  ShorterStay: string
  Status: string
}

export interface IResApiManageVillaGeneralParams {
  ID: number
  Villa: IResApiManageVillaGeneral[]
}

export interface IResApiManageVillaGeneral {
  MainID?: number
  ID?: number
  VillaID?: number
  DistanceCod?: string
  DistanceToID?: number
  DistanceToName?: string
  Distance?: number
  Note?: string
  DistanceUnit?: string
  Latitude?: number
  Longitude?: number
  Status: string
}

export class ResPropertyCompany extends SafeBaseObject {
  propertyID = 0;
  companyID = 0;
  companyName = '';

  constructor(data: any) {
    super();
    this.updateData(data);
  }
}

export interface IResApiManagePropertyDeposit {
  SchedulingPackage: IResApiManagePropertyDepositData[]
}

export interface IResApiManagePropertyDepositData {
  DepositSchedulingID: number
  PackageID: number
  PaymentDueDate: DateTime
  Currency: string
  IsFinalPayment: string
  Amount: number
  Percentage: number
  PaymentDueDays: number
  Status: string
}

export interface IResApiManagePropertyCancellation {
  PolicyPackage: IResApiManagePropertyCancellationHeader
  PolicyPackageDett: IResApiManagePropertyCancellationDetail[]
}

export interface IResApiManagePropertyCancellationHeader {
  CancellationPolicyID?: number
  PackageID?: number
  Status: string
}

export interface IResApiManagePropertyCancellationDetail {
  CancellationPolicyDetailID?: number
  CancellationPolicyID?: number
  PackageID?: number
  DaysFrom: number
  DaysTo: number
  AmountPerc?: number
  FixedAmount?: number
  ValueType?: string
  Status: string
}
export interface IResApiManageAmenities {
  VillaAmn: IResApiManageAmenitiesData[]
}

export interface IResApiManageAmenitiesData {
  VillaAmenityID?: number
  VillaAmenity?: string
  Tier?: number
  Order?: number
  ParentID?: number
  Categories?: string
  Status?: string
}

export interface IResApiGetVillaAmenities {
  VillaID?: number
  VillaAmenityID1?: number
  VillaAmenityID2?: number
  VillaAmenityID3?: number
  VillaAmenityID4?: number
}

export class ResAdmVillaAmenities extends SafeBaseObject {
  villaToAmenityID = 0
  villaID = 0
  villaAmenityID_1 = 0
  villaAmenity_T1 = ''
  tier_T1 = 0
  order_T1 = 0
  parentID_T1 = 0
  villaAmenityID_2 = 0
  villaAmenity_T2 = ''
  tier_T2 = 0
  order_T2 = 0
  parentID_T2 = 0
  villaAmenityID_3 = 0
  villaAmenity_T3 = ''
  tier_T3 = 0
  order_T3 = 0
  parentID_T3 = 0
  villaAmenityID_4 = 0
  villaAmenity_T4 = ''
  tier_T4 = 0
  order_T4 = 0
  parentID_T4 = 0
  note = ''
  included = false
  invoiceDisplay = false
  websiteDisplay = false
  resDisplay = false
  docDisplay = false

  constructor(data?: any) {
    super();
    this.updateData(data);
  }
}
export interface IResApiManageAmenitiesToVilla {
  VillaID: number
  VillaToAmn: IResApiManageSingleAmenitiesToVilla[]
}

export interface IResApiManageSingleAmenitiesToVilla {
  VillaToAmenityID?: number
  VillaID?: number
  VillaAmenityID_1?: number
  VillaAmenityID_2?: number
  VillaAmenityID_3?: number
  VillaAmenityID_4?: number
  Note?: string
  Included?: string
  InvoiceDisplay?: string
  WebsiteDisplay?: string
  RESDisplay?: string
  DOCDisplay?: string
  Status?: string
}

export class PropertyHighlightType extends SafeBaseObject {
  highlightsTypeID = 0
  highlightsDesc = ''
  scope = ''
  highlightsTypeDesc = ''
  kicker = ''

  constructor(data: any) {
    super();
    if (!data) return
    this.updateData(data);
  }
}

export class PropertyHighlight extends SafeBaseObject {
  propertyHighlightsID = 0
  propertyID = 0
  highlightsTypeID = 0
  scope = ''
  highlightsDesc = ''
  position = 0
  status = 'A'

  constructor(data: any) {
    super();
    if (!data) return
    this.updateData(data);
  }
}

export class IPropertyHighlight {
  PropertyHighlightsID?: number
  PropertyID?: number
  HighlightsTypeID?: number
  HighlightsDesc?: string
  Position?: number
  Status?: string
}

export class ResAdmVillaService extends SafeBaseObject {
  propertyOptionID = 0
  propertyID = 0
  serviceID = 0
  serviceName = ''
  optionID = 0
  optionName = ''
  priceSetupID = 0
  priceSetup = ''
  displaySequence = 0
  included = false
  startDate = DateTime.invalid('Empty')
  endDate = DateTime.invalid('Empty')
  hideInBkg = false
  quantity = 1
  status = 'A'
  supplierID = 0
  supplierName = ''
  internalNotes = ''
  productCod: 'SRV' | 'EXP' = 'SRV'

  cost = 0
  costCurrency = ''
  priceUSD = 0
  priceGBP = 0
  priceAUD = 0
  priceEUR = 0
  priceCAD = 0

  experienceID?: number
  templateID?: number

  constructor(data: any) {
    super();
    this.updateData(data);
  }
}

export interface IResApiManageVillaService {
  PropertyOption?: IResApiManageVillaServiceOption[]
}

export interface IResApiManageVillaServiceOption {
  PropertyOptionID?: number
  PropertyID?: number
  ServiceID?: number
  OptionID?: number
  PriceSetupID?: number
  DisplaySequence?: number
  StartDate?: DateTime
  EndDate?: DateTime
  HideInBkg?: string
  Quantity?: number
  Included?: string
  Status?: string
  Cost?: number
  CostCurrency?: string
  PriceUSD?: number
  PriceGBP?: number
  PriceAUD?: number
  PriceEUR?: number
  PriceCAD?: number
  InternalNotes?: string
  ExperienceID?: number
  TemplateID?: number
}

export interface IResApiManageServiceAdditionalServices {
  ServiceAdditionalOption?: IResApiManageServiceAdditionalService[]
}

export interface IResApiManageServiceAdditionalService {
  ServiceAdditionalOptionID?: number
  MainServiceID?: number
  ServiceID?: number
  OptionID?: number
  PriceSetupID?: number
  DisplaySequence?: number
  StartDate?: DateTime
  EndDate?: DateTime
  HideInBkg?: string
  Quantity?: number
  Included?: string
  Status?: string
  Cost?: number
  CostCurrency?: string
  PriceUSD?: number
  PriceGBP?: number
  PriceAUD?: number
  PriceEUR?: number
  PriceCAD?: number
  InternalNotes?: string
}

export interface IResApiGetVillaServices {
  PropertyID?: number
  ServiceName?: string
  OptionName?: string
}

export interface IResApiGetServiceAdditionalServices {
  MainServiceID?: number
  ServiceName?: string
  OptionName?: string
}

export class ResAdmPropertyAvailability extends SafeBaseObject {

  availabilitybyPropertyID = 0
  date = DateTime.invalid('Empty')
  propertyID = 0
  initialQTY = 0
  onHoldQTY = 0
  intialAllotmentQTY = 0
  onHoldAllotmentQTY = 0
  groupID = 0
  agencyID = 0
  packageID = 0

  //for tooltip
  bkgID?: string
  avlStatus?: string

  constructor(data: any) {
    super();
    this.updateData(data);
  }
}

export interface IResApiGetPropertyAvailability {
  PropertyID: number
  Year: number
}

export interface IResApiManageVillaAvailability {
  PropertyID: number
  Availability: IResApiManageVillaAvailabilityData[]
}

export interface IResApiManageVillaAvailabilityData {
  AvailabilityByPropertyID?: number
  Date?: DateTime
  PropertyID?: number
  InitialQTY?: number
  OnHoldQTY?: number
  IntialAllotmentQTY?: number
  OnHoldAllotmentQTY?: number
  GroupID?: number
  AgencyID?: number
  PackageID?: number
  Status?: string
}

export interface IResApiGetVillaContractList {
  PropertyID: number
  Year?: number
  FileName?: string
}

export class ResAdmVillaContract extends SafeBaseObject {
  propertyContractID = 0
  propertyID = 0
  year = 0
  fileName = ''
  fileID = 0
  fileGuid = ''
  notes = ''
  internalNotes = ''

  constructor(data?: any) {
    super();
    this.updateData(data);
  }
}

export interface IResApiManageVillaContract {
  PropertyID: number
  PropertyContract?: ResAdmVillaContractData[]
}

export interface ResAdmVillaContractData {
  PropertyContractID?: number
  PropertyID?: number
  Year?: number
  FileName?: string
  FileID?: number
  FileGuid?: string
  Notes?: string
  InternalNotes?: string
  Status?: string
}

export class ResAdmPropertyRuleType extends SafeBaseObject {
  propertyRulesTypeID = 0
  propertyRulesType = ''

  constructor(data: any) {
    super();
    this.updateData(data);
  }
}

export class ResAdmPropertyRule extends SafeBaseObject {
  propertyRulesID = 0
  propertyID = 0
  propertyRulesTypeID = 0
  propertyRulesType = ''
  night = 0
  startDate = DateTime.invalid('Empty')
  endDate = DateTime.invalid('Empty')
  note = ''
  status = 'A'

  constructor(data: any) {
    super();
    this.updateData(data);
  }
}

export interface IResApiGetPropertyRules {
  PropertyID: number
  PropertyRulesTypeID: number
  StartDate?: DateTime
  EndDate?: DateTime
  Status?: string
}

export interface IResApiManagePropertyRule {
  PropertyID: number
  Rules: IResApiManagePropertyRuleData[]
}

export interface IResApiManagePropertyRuleData {
	PropertyRulesID?: number
	PropertyRulesTypeID?: number
	PropertyID?: number
	Night?: number
	StartDate?: DateTime
	EndDate?: DateTime
	Note?: string
	Status?: string
}

export interface IResApiCloneProperty {
  PropertyID: number
  PropertyName: string
  PropertyCod: string
  ClonePrc: string
  CloneAvl: string
}

export class ResAdmAmenityCategories extends SafeBaseObject {
  scope = ''
  position = 0
  cod = ''
  description = ''

  constructor(data: any) {
    super();
    this.updateData(data);
  }
}

export class ResAdmCampSupplier extends SafeBaseObject {
  supplierID = 0
  supplierName = ''

  constructor(data: any) {
    super();
    this.updateData(data);
  }
}

export interface IResApiCloneExperience {
  ExperienceID: number
  ExperienceName: string
  ExperienceCode: string
}